<template>
  <div>
    <portal to="context-portal">
      <ul class="pa-0" style="display: flex;">
        <li v-for="type in types" :key="type.type" style="list-style-type:none;">
          <!--<v-switch
            v-model="type.enabled"
            size="sm"
            class="activity-type-slider mr-1"
            :class="type.enabled ? 'enabled' : ''"
          />-->
          <v-btn small class="activity-type-button" :class="type.enabled ? 'elevation-4 enabled' : 'elevation-0'"
                 :title="type.caption" @click="type.enabled = (!type.enabled)">
          <img
            :src="$ic.getImageUrl('activity', type.type)"
            class="medium-thumbnail" :class="type.enabled ? 'image-white' : ' image-accent-dark'"
          />
          </v-btn>
        </li>
      </ul>
    </portal>
    <v-data-table
      :items="filteredYears"
      :headers="headers"
      :rows-per-page-items="[10,20,50,100]"
      hide-actions
      disable-initial-sort
      class="table-hover-cell-highlight"
    >
      <template #headers="props">
        <td
          v-for="header in props.headers"
          :key="header.value"
          class="pa-0"
          :class="header.value !== 'year' ? 'vertical-header' : ''"
        >
          <div class="ml-4">
            <span class="accentDark--text">{{ header.value !== 'year' ? header.text :'' }}</span>
          </div>
        </td>
      </template>
      <template #items="props">
        <td class="text-xs-right accentDark--text">{{ props.item.year }}</td>
        <td
          v-for="month in months"
          :key="`${props.item.year}-${month}`"
          class="text-xs-right pa-1 highlight-cell"
        >
          <div v-if="props.item[month.toLowerCase()] 
             && (props.item[month.toLowerCase()].xxx) 
             && (props.item[month.toLowerCase()].xxx.length > 0)">
            <activity-collection-cell :activities="props.item[month.toLowerCase()].xxx" />
          </div>
          <!--<div
            v-if="props.item[month.toLowerCase()] && (props.item[month.toLowerCase()].distance > 0)"
          >
            <h5
              class="data-cell"
              v-html="$bc.distanceFormat(props.item[month.toLowerCase()].distance,'major')"
            />
            <h5
              class="data-cell"
              v-html="$bc.elevationFormat(props.item[month.toLowerCase()].elevation)"
            />
            <h5
              class="data-cell"
              v-html="$bc.timeFormat(props.item[month.toLowerCase()].elapsed_time)"
            />
          </div>-->
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment';
import dataAccessor from '@/data-access/dataAccessor';
import loadingMixin from '@/mixins/loadingMixin';
import StringTools from '@/library/StringTools';
import ActivityCollectionCell from "./AcivityCollectionCell.vue";
import linq from '../../../library/linq';

export default {
  name: 'activity-month-summary-table',
  mixins: [loadingMixin],
  components: { ActivityCollectionCell },
  data: () => ({
    years: [],
    types: [],
  }),
  computed: {
    months() {
      return Array.apply(0, Array(12)).map((_, i) => moment().month(i).format('MMMM'));
    },
    headers() {
      return [{ text: 'Year', value: 'year' }].concat(this.months.map((m) => ({ text: m, value: m.toLowerCase(), align: 'right' })));
    },
    filteredYears() {
      return this.years.map((y) => this.calcFilteredYear(y));
    },
    filteredTypes() {
      return this.types.filter((t) => t.enabled).map((t) => t.type);
    },
  },
  async mounted() {
    await this.sync();
  },
  methods: {
    calcFilteredYear(year) {
      const y = { year: year.year };
      this.months.forEach((m) => y[m.toLowerCase()] = this.calcFilteredCell(year[m.toLowerCase()]));
      return y;
    },
    calcFilteredCell(cell) {
      const activities = cell && cell.activities ? cell.activities : []
      const filteredActivities = activities.filter((a) => this.filteredTypes.includes((a.type)));
      return {
        activities: activities,
        filteredActivities: filteredActivities,
        xxx: filteredActivities,
        distance: linq.sum(filteredActivities, (a) => a.distance),
        elevation: linq.sum(filteredActivities, (a) => a.total_elevation_gain),
        elapsed_time: linq.sum(filteredActivities, (a) => a.elapsed_time),
        kudos_count: linq.sum(filteredActivities, (a) => a.kudos_count),
      }
    },
    async sync() {
      this.loadingStart('Loading activities');
      let activities = [];
      let items = await dataAccessor.sync(
        async (c, t, act) => {
          this.progress = { current: c, total: t };
          activities = act;
          this.loadingProgress('Loading activities', c > 0 ? Math.round((c * 100) / t) : 0);
        },
        0,
      );
      this.loadingEnd();
      this.types = linq.distinctValues(items.map((i) => i.type)).map((t) => ({
        type: t,
        enabled: true,
        caption: StringTools.toSentenceCase(t)
      }));
      let m = items.map((a) => {
        a.month_key = moment(a.start_date).format('MMMM:YYYY');
        return a;
      }
      );
      const months = linq.groupBy(m, 'month_key').map((g) => ({ month: g[0], activities: g[1] }));
      const years = [];
      months.forEach((m) => {
        const key = m.month.split(':');
        const year = parseInt(key[1], 10);
        let y = years.find((y) => y.year === year);
        if (!y) {
          y = { year: year };
          this.months.forEach((m) => y[m.toLowerCase()] = null);
          years.push(y);
        }
        y[key[0].toLowerCase()] = this.calcFilteredCell({ activities: m.activities });
      });
      years.sort((a, b) => b.year - a.year);
      this.years = years;
    },
  }
};
</script>